import * as React from "react";

import { ApolloProvider } from "react-apollo";
import { ThemeProvider } from "styled-components";

import { GlobalStyle, Main } from "cms/theme/GlobalStyle";
import { ThemeMode, themes } from "cms/theme/theme";
import { createApolloClient } from "network";
import { trackPromos, trackQueryParams } from "tracking";

const apolloClient = createApolloClient();

export interface LayoutProps {
  themeMode?: ThemeMode;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ themeMode = "light", children }) => {
  React.useEffect(() => {
    trackQueryParams();
    trackPromos();
  }, []);

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={themes[themeMode]}>
        <Main>{children}</Main>
        <GlobalStyle />
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default Layout;
